package org.example.project.screens_cus

import org.example.project.dashboard.AppDialogs

import androidx.compose.runtime.*
import kotlinx.browser.window
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.example.project.dashboard.DashboardTheme
import org.example.project.enginekalender.loadServiceKalenderBookings
import org.example.project.enginekalender.searchServiceKalenderBookings
import org.example.project.engineservice.ServiceApi
import org.example.project.enginemodule.ModulShopDashboardNavState
import org.example.project.enginemodule.moduleVersionKey
import org.example.project.enginetabular.TABULAR_CALENDAR_ICON_VALUE
import org.example.project.enginetabular.TABULAR_DOCUMENT_ICON_VALUE
import org.example.project.enginetabular.TABULAR_MINE_CONTENT_ICON_VALUE
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.CustomerApi
import org.example.project.service.GlobalManager
import org.example.project.service.LoginService
import org.example.project.service.ZustandManager
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

object CUSCeoDashboardStyles : StyleSheet() {
    val screenRoot by style {
        width(100.percent)
        height(100.percent)
        minHeight(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        padding(28.px)
        boxSizing("border-box")
        color(DashboardTheme.TEXT_LIGHT)
        overflow("hidden")
    }

    val stickyTop by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        flex("0 0 auto")
    }

    val tileScrollHost by style {
        width(100.percent)
        minWidth(0.px)
    }

    val greeting by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        textAlign("center")
        padding(18.px, 0.px, 36.px, 0.px)
        gap(12.px)
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(24.px)
        fontWeight("750")
        lineHeight("1.1")
    }

    val monthlyUsage by style {
        textAlign("center")
        padding(0.px, 0.px, 100.px, 0.px)
        color(DashboardTheme.TEXT_MUTED)
        fontSize(16.px)
        fontWeight("600")
        lineHeight("1.2")
    }

    val monthlyUsageValue by style {
        color(DashboardTheme.TEXT_LIGHT)
        fontWeight("750")
        property("text-decoration", "underline")
        property("text-underline-offset", "4px")
    }

    val monthlyUsageAmountLine by style {
        width(100.percent)
        textAlign("center")
    }

    val grid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(auto-fit, minmax(180px, 1fr)) !important")
        justifyContent(JustifyContent.Center)
        justifyItems("center")
        alignItems(AlignItems.Stretch)
        gap(10.px)
        property("width", "100% !important")
        boxSizing("border-box")
        marginBottom(100.px)
    }

    val tabularArea by style {
        width(100.percent)
        maxWidth(1556.px)
        flex("1 1 auto")
        minHeight(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        overflow("hidden")
    }

    val tile by style {
        width(100.percent)
        height(80.px)
        padding(8.px)
        boxSizing("border-box")
        borderRadius(8.px)
        backgroundColor(DashboardTheme.SURFACE_CARD)
        property("border", "1px solid ${DashboardTheme.BORDER_LIGHT}")
        display(DisplayStyle.Grid)
        gridTemplateColumns("60px minmax(0, 1fr)")
        gridTemplateRows("1fr")
        gap(8.px)
        position(Position.Relative)
    }

    val tileClickable by style {
        cursor("pointer")
    }

    val tileActive by style {
        property("border", "1px solid ${DashboardTheme.ACCENT}")
    }

    val iconSlot by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
    }

    val icon by style {
        width(40.px)
        height(40.px)
        property("filter", DashboardTheme.ICON_FILTER_WHITE)
    }

    val textColumn by style {
        display(DisplayStyle.Grid)
        gridTemplateRows("1fr 1fr")
        alignItems(AlignItems.Center)
        justifyItems("center")
        minWidth(0.px)
    }

    val tileLabel by style {
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(14.px)
        fontWeight("700")
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        textAlign("center")
        width(100.percent)
    }


    val tileHint by style {
        color(DashboardTheme.TEXT_MUTED)
        fontSize(12.px)
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
    }

    val value by style {
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(20.px)
        fontWeight("750")
        lineHeight("1")
        property("white-space", "nowrap")
        textAlign("center")
        width(100.percent)
    }

    val divider by style {
        width(100.percent)
        maxWidth(1556.px)
        height(1.px)
        backgroundColor(DashboardTheme.BORDER_LIGHT)
    }

    val verbrauchTable by style {
        width(100.percent)
        maxWidth(1556.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
        flex("1 1 auto")
        minHeight(0.px)
        overflow("hidden")
    }

    val tableHeader by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("130px repeat(7, minmax(0, 1fr))")
        columnGap(12.px)
        padding(0.px, 0.px, 10.px, 0.px)
        color(DashboardTheme.TEXT_MUTED)
        fontSize(12.px)
        fontWeight("700")
    }

    val tableHeaderInvoice by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("130px repeat(7, minmax(0, 1fr)) 44px")
        columnGap(12.px)
        padding(0.px, 0.px, 10.px, 0.px)
        color(DashboardTheme.TEXT_MUTED)
        fontSize(12.px)
        fontWeight("700")
    }

    val tableRow by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("130px repeat(7, minmax(0, 1fr))")
        columnGap(12.px)
        padding(11.px, 0.px)
        property("border-top", "1px solid ${DashboardTheme.BORDER_LIGHT}")
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(13.px)
    }

    val tableRowInvoice by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("130px repeat(7, minmax(0, 1fr)) 44px")
        columnGap(12.px)
        padding(11.px, 0.px)
        property("border-top", "1px solid ${DashboardTheme.BORDER_LIGHT}")
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(13.px)
    }

    val formulaRow by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("160px minmax(0, 1fr) 140px")
        columnGap(12.px)
        padding(11.px, 0.px)
        property("border-top", "1px solid ${DashboardTheme.BORDER_LIGHT}")
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(13.px)
    }

    val tableCell by style {
        minWidth(0.px)
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
    }

}

@Composable
fun CUSCeoDashboard() {
    Style(CUSCeoDashboardStyles)

    var loading by remember { mutableStateOf(true) }
    var tiles by remember { mutableStateOf<List<All>>(emptyList()) }
    var selectedPanel by remember { mutableStateOf("") }
    var verbrauchRows by remember { mutableStateOf<List<All>>(emptyList()) }
    var termineRows by remember { mutableStateOf<List<All>>(emptyList()) }
    var supportRows by remember { mutableStateOf<List<All>>(emptyList()) }
    var crRows by remember { mutableStateOf<List<All>>(emptyList()) }
    var moduleRows by remember { mutableStateOf<List<All>>(emptyList()) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        val loaded = loadCeoDashboardData()
        tiles = loaded.first.first.first
        loading = false
    }

    Div({ classes(CUSCeoDashboardStyles.screenRoot) }) {
        Div({ classes(CUSCeoDashboardStyles.stickyTop) }) {
            Div({ classes(CUSCeoDashboardStyles.grid) }) {
                tiles.forEach { tile ->
                    CeoDashboardTile(
                        tile = tile,
                        loading = loading,
                        active = selectedPanel == tile.key,
                        onClick = { selectedPanel = tile.key }
                    )
                }
            }
        }

        Div({ classes(CUSCeoDashboardStyles.tabularArea) }) {
            if (selectedPanel == "CUSRechnungsuebersicht") {
                VerbrauchMonateTable(verbrauchRows) { filters ->
                    scope.launch { verbrauchRows = CustomerApi.searchVerbrauchMonate(filters) }
                }
            }
            if (selectedPanel == "CUSTerminauskunft") {
                TermineSmartTable(termineRows) { filters ->
                    scope.launch { termineRows = searchServiceKalenderBookings(filters) }
                }
            }
            if (selectedPanel == "CUSSupportAuskunft") {
                SupportSmartTable(supportRows) { filters ->
                    scope.launch { supportRows = ServiceApi.searchSupport("company", filters) }
                }
            }
            if (selectedPanel == "CUSCRAuskunft") {
                CrSmartTable(crRows) { filters ->
                    scope.launch { crRows = ServiceApi.searchCr("company", filters) }
                }
            }
            if (selectedPanel == "CUSModule") {
                ModuleSmartTable(moduleRows) { filters ->
                    scope.launch { moduleRows = CustomerApi.searchModules(filters) }
                }
            }
        }
    }
}

@Composable
private fun CeoDashboardTile(
    tile: All,
    loading: Boolean,
    active: Boolean,
    onClick: () -> Unit
) {
    Div({
        if (active) {
            classes(CUSCeoDashboardStyles.tile, CUSCeoDashboardStyles.tileClickable, CUSCeoDashboardStyles.tileActive)
        } else {
            classes(CUSCeoDashboardStyles.tile, CUSCeoDashboardStyles.tileClickable)
        }
        onClick { onClick() }
    }) {
        Div({ classes(CUSCeoDashboardStyles.iconSlot) }) {
            Img(src = tile.icon, attrs = { classes(CUSCeoDashboardStyles.icon) })
        }
        Div({ classes(CUSCeoDashboardStyles.textColumn) }) {
            Div({ classes(CUSCeoDashboardStyles.tileLabel) }) { Text(tile.label) }
            Div({ classes(CUSCeoDashboardStyles.value) }) {
                Text(if (loading) "..." else tile.bezeichnung)
            }
        }
    }
}

@Composable
private fun VerbrauchAktuellPanel(current: All?) {
    val row = current ?: All(datum = currentCeoMonthKey())
    Div({ classes(CUSCeoDashboardStyles.verbrauchTable) }) {
        Div({ classes(CUSCeoDashboardStyles.tableHeader) }) {
            listOf("aktueller Monat", "Lizensierung", "CR", "Support", "Meeting", "Schulung", "Beratung", "Summe").forEach {
                Div({ classes(CUSCeoDashboardStyles.tableCell) }) { Text(it) }
            }
        }
        Div({ classes(CUSCeoDashboardStyles.tableRow) }) {
            listOf(
                yearMonthLabel(row.datum.ifBlank { currentCeoMonthKey() }),
                euroValue(ceoVerbrauchValue(row, "lizensierungPreis")),
                euroValue(ceoVerbrauchValue(row, "crKosten")),
                euroValue(ceoVerbrauchValue(row, "supportKosten")),
                euroValue(ceoVerbrauchValue(row, "meetingKosten")),
                euroValue(ceoVerbrauchValue(row, "schulungKosten")),
                euroValue(ceoVerbrauchValue(row, "beratungKosten")),
                euroValue(ceoVerbrauchValue(row, "gesamtbetragEuro"))
            ).forEach {
                Div({ classes(CUSCeoDashboardStyles.tableCell) }) { Text(it) }
            }
        }
        Div({ classes(CUSCeoDashboardStyles.divider) })
        verbrauchFormulaRows(row).forEach { item ->
            Div({ classes(CUSCeoDashboardStyles.formulaRow) }) {
                Div({ classes(CUSCeoDashboardStyles.tableCell) }) { Text(item.label) }
                Div({ classes(CUSCeoDashboardStyles.tableCell) }) { Text(item.beschreibung.orEmpty()) }
                Div({ classes(CUSCeoDashboardStyles.tableCell) }) { Text(item.bezeichnung) }
            }
        }
    }
}

@Composable
private fun VerbrauchMonateTable(rows: List<All>, onSearch: (Map<String, String>) -> Unit) {
    val scope = rememberCoroutineScope()
    val headers = listOf("Jahr Monat", "Onboarding", "Lizensierung", "CR", "Support", "Meeting", "Schulung", "Beratung", "Summe", "PDF")
    DashboardTabularScreen(
        screenKey = "CEODashboard_Verbrauch",
        title = "Verbrauch",
        headers = headers,
        data = rows.map { row ->
            row.datum.ifBlank { row.id } to listOf(
                    yearMonthLabel(row.datum),
                    euroValue(ceoVerbrauchValue(row, "onboardingPreis")),
                    euroValue(ceoVerbrauchValue(row, "lizensierungPreis")),
                    euroValue(ceoVerbrauchValue(row, "crKosten")),
                    euroValue(ceoVerbrauchValue(row, "supportKosten")),
                    euroValue(ceoVerbrauchValue(row, "meetingKosten")),
                    euroValue(ceoVerbrauchValue(row, "schulungKosten")),
                    euroValue(ceoVerbrauchValue(row, "beratungKosten")),
                    euroValue(ceoVerbrauchValue(row, "gesamtbetragEuro")),
                    TABULAR_DOCUMENT_ICON_VALUE
                )
        },
        onSearchWithFilters = onSearch,
        onCellClick = { rowId, colIndex ->
            if (colIndex == headers.lastIndex) {
                rows.firstOrNull { it.datum.ifBlank { it.id } == rowId }?.let { row ->
                    scope.launch { openRechnungDocument(row) }
                }
            }
        }
    )
}

@Composable
private fun TermineSmartTable(rows: List<All>, onSearch: (Map<String, String>) -> Unit) {
    val headers = listOf("Datum", "Zeit", "Art", "Ort", "Status", "Kalender")
    DashboardTabularScreen(
        screenKey = "CEODashboard_Termine",
        title = "Termine",
        headers = headers,
        data = rows.sortedByDescending { it.datum }.map { termin ->
            termin.id.ifBlank { "${termin.datum}_${termin.uhrzeitVon}" } to
            listOf(
                termin.datum,
                listOf(termin.uhrzeitVon, termin.uhrzeitBis).filter { it.isNotBlank() }.joinToString(" - "),
                termin.terminArt.ifBlank { "Termin" },
                termin.ort,
                ZustandManager.Termin.textFor(termin.zustand),
                TABULAR_CALENDAR_ICON_VALUE
            )
        },
        onSearchWithFilters = onSearch,
        onCellClick = { rowId, colIndex ->
            if (colIndex == headers.lastIndex) {
                routeToDashboardScreen("CUSTerminauskunft", "terminId" to rowId)
            }
        }
    )
}

@Composable
private fun SupportSmartTable(rows: List<All>, onSearch: (Map<String, String>) -> Unit) {
    val scope = rememberCoroutineScope()
    val headers = listOf("Ticketnummer", "Screen", "Art", "KI Auswahl", "Mitarbeiter", "Datum", "Zustand", "PDF")
    DashboardTabularScreen(
        screenKey = "CEODashboard_Support",
        title = "Support",
        headers = headers,
        data = rows.sortedByDescending { it.id.toIntOrNull() ?: 0 }.map { ticket ->
            ticket.id.ifBlank { ticket.ticketnummer.ifBlank { ticket.supportTicket } } to
                        listOf(
                            ticket.ticketnummer.ifBlank { ticket.supportTicket.ifBlank { ticket.id } },
                            allNameLabel(ticket.screenKey.ifBlank { ticket.ticketgrund }),
                            ticket.supportart,
                            ticket.kiAuswahl,
                            listOf(ticket.vorname, ticket.nachname).filter { it.isNotBlank() }.joinToString(" ").ifBlank { ticket.personalnummer },
                            ticket.bearbeitetAm.ifBlank { ticket.erstelltAm.ifBlank { ticket.datum } },
                            ZustandManager.Support.textFor(ticket.zustand),
                            TABULAR_DOCUMENT_ICON_VALUE
                        )
        },
        onSearchWithFilters = onSearch,
        onCellClick = { rowId, colIndex ->
            if (colIndex == headers.lastIndex) {
                rows.firstOrNull { it.id.ifBlank { it.ticketnummer.ifBlank { it.supportTicket } } == rowId }?.let { ticket ->
                    scope.launch { openSupportPdf(ticket) }
                }
            }
        }
    )
}

@Composable
private fun CrSmartTable(rows: List<All>, onSearch: (Map<String, String>) -> Unit) {
    val scope = rememberCoroutineScope()
    val headers = listOf("CR ID", "Betreff", "Art", "Aufwand geschätzt", "Aufwand final", "Zustand", "PDF")
    DashboardTabularScreen(
        screenKey = "CEODashboard_CR",
        title = "CR",
        headers = headers,
        data = rows.sortedByDescending { it.id.toIntOrNull() ?: 0 }.map { cr ->
            cr.id.ifBlank { cr.crNummer } to
                        listOf(
                            cr.crNummer.ifBlank { cr.id },
                            cr.crBeschreibung,
                            crArtLabel(cr),
                            cr.crAufwandStunden.takeIf { it > 0 }?.let { "$it h" }.orEmpty(),
                            cr.crAufwandFinal.takeIf { it > 0 }?.let { "$it h" }.orEmpty(),
                            ZustandManager.CR.textFor(cr.zustand),
                            TABULAR_DOCUMENT_ICON_VALUE
                        )
        },
        onSearchWithFilters = onSearch,
        onCellClick = { rowId, colIndex ->
            if (colIndex == headers.lastIndex) {
                rows.firstOrNull { it.id.ifBlank { it.crNummer } == rowId }?.let { cr ->
                    scope.launch { openCrPdf(cr) }
                }
            }
        }
    )
}

@Composable
private fun ModuleSmartTable(rows: List<All>, onSearch: (Map<String, String>) -> Unit) {
    val headers = listOf("Modul", "Referenz", "Typ", "Status", "Meine Inhalte")
    DashboardTabularScreen(
        screenKey = "CEODashboard_Module",
        title = "Module",
        headers = headers,
        data = rows.sortedBy { it.modulName.lowercase() }.map { module ->
            module.moduleVersionKey() to
            listOf(
                module.modulName.ifBlank { module.label.ifBlank { module.id } },
                module.modulReferenz,
                module.modulTyp,
                if (module.modulInstalliert || module.modulAktiv) "installiert" else "im Besitz",
                TABULAR_MINE_CONTENT_ICON_VALUE
            )
        },
        onSearchWithFilters = onSearch,
        onCellClick = { rowId, colIndex ->
            if (colIndex == headers.lastIndex) {
                ModulShopDashboardNavState.openMineModule(rowId)
                routeToDashboardScreen("Modul Shop")
            }
        }
    )
}

@Composable
private fun DashboardTabularScreen(
    screenKey: String,
    title: String,
    headers: List<String>,
    data: List<Pair<String, List<String>>>,
    onSearchWithFilters: ((Map<String, String>) -> Unit)? = null,
    onCellClick: ((String, Int) -> Unit)? = null
) {
    Div({ classes(CUSCeoDashboardStyles.verbrauchTable) }) {
        TabularScreen(
            screenKey = screenKey,
            rollenKey = "",
            title = title,
            headers = headers,
            data = data,
            editable = false,
            hardReadOnly = true,
            includeMetadata = false,
            nonEditableCols = headers.toSet(),
            allowCreate = false,
            allowDelete = false,
            allowSave = false,
            allowImportButton = false,
            allowExportButton = true,
            allowRefreshButton = true,
            allowSearchButton = true,
            allowSettingsButton = true,
            useUserSettings = false,
            smartMode = true,
            onSearchWithFilters = onSearchWithFilters,
            onCellClick = onCellClick,
            onCommit = {}
        )
    }
}

private fun routeToDashboardScreen(screenKey: String, vararg params: Pair<String, String>) {
    val baseHash = window.location.hash.substringBefore("?").ifBlank { "#/dashboard" }
    fun encode(value: String): String = js("encodeURIComponent")(value) as String
    val query = buildList {
        add("screen=${encode(screenKey)}")
        params.forEach { (key, value) ->
            if (value.isNotBlank()) add("${encode(key)}=${encode(value)}")
        }
    }.joinToString("&")
    window.location.hash = "$baseHash?$query"
}

private suspend fun loadCeoDashboardData(): Pair<Pair<Pair<List<All>, List<All>>, Pair<List<All>, List<All>>>, Pair<Pair<List<All>, List<All>>, All?>> {
    val firmenId = currentCeoFirmenId()
    val monthKey = currentCeoMonthKey()
    val support = runCatching { ServiceApi.loadSupport("company") }.getOrDefault(emptyList())
    val crs = runCatching { ServiceApi.loadCr("company") }.getOrDefault(emptyList())
    val module = firmenId.takeIf { it.isNotBlank() }
        ?.let { runCatching { CustomerApi.loadModules(it) }.getOrDefault(emptyList()) }
        ?: emptyList()
    val termine = runCatching { loadServiceKalenderBookings() }.getOrDefault(emptyList())
        .filter { it.kundeFirmenId == firmenId }
    val verbrauch = firmenId.takeIf { it.isNotBlank() }
        ?.let { runCatching { CustomerApi.loadVerbrauch(it, monthKey) }.getOrNull() }
    val rechnungen = firmenId.takeIf { it.isNotBlank() }
        ?.let { runCatching { CustomerApi.loadVerbrauchMonate(it) }.getOrDefault(emptyList()) }
        ?: emptyList()
    val verbrauchRows = buildVerbrauchRows(monthKey, verbrauch, rechnungen)

    val tiles = listOf(
        ceoTile(
            key = "CUSRechnungsuebersicht",
            label = "Verbrauch",
            icon = "images/money.svg",
            value = euroText(ceoVerbrauchValue(verbrauch, "gesamtbetragEuro")).ifBlank { "0" },
            hint = "aktueller Monat"
        ),
        ceoTile(
            key = "CUSTerminauskunft",
            label = "Termine",
            icon = "images/kalender.svg",
            value = termine.size.toString(),
            hint = "aktuell"
        ),
        ceoTile(
            key = "CUSSupportAuskunft",
            label = "Support",
            icon = "images/supportauskunft.svg",
            value = support.size.toString(),
            hint = "Tickets"
        ),
        ceoTile(
            key = "CUSCRAuskunft",
            label = "CR",
            icon = "images/crinfo.svg",
            value = crs.size.toString(),
            hint = "Change Requests"
        ),
        ceoTile(
            key = "CUSModule",
            label = "Module",
            icon = "images/modulshop.svg",
            value = module.size.toString(),
            hint = "im Besitz"
        )
    )

    return ((tiles to verbrauchRows) to (termine to support)) to ((crs to module) to verbrauch)
}

private fun ceoTile(key: String, label: String, icon: String, value: String, hint: String): All =
    All(key = key, label = label, icon = icon, bezeichnung = value, beschreibung = hint)

private fun crArtLabel(cr: All): String = when {
    cr.crNeuesModul -> "Neues Modul"
    cr.crAenderungAktivModul.isNotBlank() -> "Änderung: ${cr.crAenderungAktivModul}"
    else -> "Änderung"
}

private fun allNameLabel(key: String): String =
    All.names[key].orEmpty().ifBlank { key }

private fun ceoVerbrauchValue(row: All?, key: String): String {
    val value = when (key) {
        "onboardingPreis" -> row?.onboardingPreis
        "lizensierungPreis" -> row?.lizensierungPreis
        "crStd" -> row?.crStd
        "crKosten" -> row?.crKosten
        "supportTickets" -> row?.supportTickets
        "supportKosten" -> row?.supportKosten
        "meetingStd" -> row?.meetingStd
        "meetingKosten" -> row?.meetingKosten
        "schulungStd" -> row?.schulungStd
        "schulungKosten" -> row?.schulungKosten
        "beratungStd" -> row?.beratungStd
        "beratungKosten" -> row?.beratungKosten
        "gesamtbetragEuro" -> row?.gesamtbetragEuro
        "monat" -> row?.monat
        else -> ""
    }
    return value.orEmpty()
}

private suspend fun openSupportPdf(ticket: All) {
    val ticketId = ticket.id.ifBlank { ticket.ticketnummer.ifBlank { ticket.supportTicket } }
    val fileName = ServiceApi.supportPdfFileName(ticket)
    ServiceApi.openSupportDocument(ticketId, fileName, logMissing = false)
}

private suspend fun openCrPdf(cr: All) {
    val crId = cr.id.ifBlank { cr.crNummer }
    val fileName = cr.crAngebotPdf.ifBlank { ServiceApi.crPdfFileName(cr) }
    ServiceApi.openCrDocument(crId, fileName)
}

private fun euroValue(value: String): String {
    val clean = value.trim().ifBlank { "0" }
    return if (clean.contains("€") || clean.contains("EUR", ignoreCase = true)) clean else "$clean €"
}

private fun euroText(value: String): String {
    val amount = parseEuro(value)
    if (value.isBlank() || amount <= 0.0) return ""
    val wholeEuro = kotlin.math.round(amount).toLong()
    return "${wholeEuro.toString().reversed().chunked(3).joinToString(".").reversed()} €"
}

private fun buildVerbrauchRows(monthKey: String, current: All?, months: List<All>): List<All> {
    val currentRow = (current ?: All(datum = monthKey)).copy(datum = current?.datum.orEmpty().ifBlank { monthKey })
    val history = months
        .filter { it.datum.ifBlank { it.monat } != monthKey }
        .map { row -> row.copy(datum = row.datum.ifBlank { row.monat }) }
        .sortedByDescending { it.datum }
    return listOf(currentRow) + history
}

private fun verbrauchFormulaRows(row: All): List<All> =
    listOf(
        verbrauchFormula("Lizensierung", "1", ceoVerbrauchValue(row, "lizensierungPreis"), ceoVerbrauchValue(row, "lizensierungPreis")),
        verbrauchFormula("CR", ceoVerbrauchValue(row, "crStd"), unitPrice(ceoVerbrauchValue(row, "crKosten"), ceoVerbrauchValue(row, "crStd")), ceoVerbrauchValue(row, "crKosten")),
        verbrauchFormula("Support", ceoVerbrauchValue(row, "supportTickets"), unitPrice(ceoVerbrauchValue(row, "supportKosten"), ceoVerbrauchValue(row, "supportTickets")), ceoVerbrauchValue(row, "supportKosten")),
        verbrauchFormula("Meeting", ceoVerbrauchValue(row, "meetingStd"), unitPrice(ceoVerbrauchValue(row, "meetingKosten"), ceoVerbrauchValue(row, "meetingStd")), ceoVerbrauchValue(row, "meetingKosten")),
        verbrauchFormula("Schulung", ceoVerbrauchValue(row, "schulungStd"), unitPrice(ceoVerbrauchValue(row, "schulungKosten"), ceoVerbrauchValue(row, "schulungStd")), ceoVerbrauchValue(row, "schulungKosten")),
        verbrauchFormula("Beratung", ceoVerbrauchValue(row, "beratungStd"), unitPrice(ceoVerbrauchValue(row, "beratungKosten"), ceoVerbrauchValue(row, "beratungStd")), ceoVerbrauchValue(row, "beratungKosten"))
    )

private fun verbrauchFormula(label: String, menge: String, preis: String, wert: String): All {
    val amount = menge.ifBlank { "0" }
    val price = euroValue(preis)
    val total = euroValue(wert)
    return All(label = label, beschreibung = "$amount x $price = $total", bezeichnung = total)
}

private fun unitPrice(total: String, amount: String): String {
    val totalValue = parseEuro(total)
    val amountValue = parseEuro(amount)
    if (totalValue <= 0.0 || amountValue <= 0.0) return ""
    return formatEuroNumber(totalValue / amountValue)
}

private fun parseEuro(value: String): Double =
    value.replace("€", "")
        .replace("EUR", "", ignoreCase = true)
        .replace(".", "")
        .replace(",", ".")
        .trim()
        .toDoubleOrNull()
        ?: 0.0

private fun formatEuroNumber(value: Double): String {
    if (value <= 0.0) return ""
    val rounded = kotlin.math.round(value * 100.0) / 100.0
    return if (rounded % 1.0 == 0.0) rounded.toInt().toString() else rounded.toString().replace(".", ",")
}

private suspend fun openRechnungDocument(row: All) {
    val entryId = row.id.ifBlank { "${row.firmenId}_${row.datum}" }
    if (entryId.isBlank()) return
    val pdf = ServiceApi.serviceDocuments("rechnung", entryId)
        .firstOrNull { document ->
            val fileName = document.file.ifBlank { document.name }
            fileName.endsWith(".pdf", ignoreCase = true)
        }
    if (pdf == null) {
        AppDialogs.alert("Für diesen Monat ist noch kein Rechnungs-PDF vorhanden.")
        return
    }
    val opened = ServiceApi.openServiceDocumentMeta("rechnung", entryId, pdf, logMissing = true)
    if (!opened) AppDialogs.alert("Das Rechnungs-PDF konnte nicht geöffnet werden.")
}

private fun yearMonthLabel(monthKey: String): String {
    val year = monthKey.substringBefore("_", monthKey)
    val month = monthKey.substringAfter("_", "").toIntOrNull()
    val monthName = when (month) {
        1 -> "Januar"
        2 -> "Februar"
        3 -> "März"
        4 -> "April"
        5 -> "Mai"
        6 -> "Juni"
        7 -> "Juli"
        8 -> "August"
        9 -> "September"
        10 -> "Oktober"
        11 -> "November"
        12 -> "Dezember"
        else -> monthKey
    }
    return if (month == null) monthKey else "$year $monthName"
}

private fun monthYearLabel(monthKey: String): String {
    val year = monthKey.substringBefore("_", monthKey)
    val month = monthKey.substringAfter("_", "").toIntOrNull()
    val monthName = when (month) {
        1 -> "Januar"
        2 -> "Februar"
        3 -> "März"
        4 -> "April"
        5 -> "Mai"
        6 -> "Juni"
        7 -> "Juli"
        8 -> "August"
        9 -> "September"
        10 -> "Oktober"
        11 -> "November"
        12 -> "Dezember"
        else -> monthKey
    }
    return if (month == null) monthKey else "$monthName $year"
}

private fun currentCeoFirmenId(): String =
    LoginService.getUser()?.firmenId.orEmpty().trim().ifBlank { GlobalManager.currentFirmenId.trim() }

private fun currentCeoMonthKey(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    return "${now.year}_${now.monthNumber.toString().padStart(2, '0')}"
}
